import { PrivateMedicalInsuranceCmsDataType } from "../types/private-medical-insurance.type";

export function groupedCoverForCmsData(
  cmsData: PrivateMedicalInsuranceCmsDataType,
  isExperimentEnabled?: boolean
) {
  const cmsDataObj = cmsData.personalMedicalQuestionArea["0"];

  const groupedCmsData = {
    NOT_COMPLETED: {
      isLoadMoreButton: isExperimentEnabled
        ? cmsDataObj.pmiExperimentIsLoadMoreButton
        : cmsDataObj.isLoadMoreButton,
      isLoadMoreButtonText: isExperimentEnabled
        ? cmsDataObj.pmiExperimentIsLoadMoreButtonText
        : cmsDataObj.isLoadMoreButtonText,
      title: isExperimentEnabled
        ? cmsDataObj.pmiExperimentSupportSectionTitle
        : cmsDataObj.defaultSupportSectionTitle,
      description: isExperimentEnabled
        ? cmsDataObj.pmiExperimentSupportSectionDescription
        : cmsDataObj.defaultSupportSectionDescription,
    },
    COMPLETED: {
      title: cmsDataObj.filledSupportSectionTitle,
      description: cmsDataObj.filledSupportSectionDescription,
    },
  };

  return groupedCmsData;
}
